/**
 * Código do login por QR Code: "<id>.<exp>.<sig>", onde `exp` é epoch em
 * segundos (120 dias a partir da geração) e `sig` é o HMAC-SHA256 de
 * "<id>.<exp>" usando o `uuid` do aluno como chave (hex, 32 chars). O uuid não
 * vai no QR. A API (POST /qr_authenticate) recalcula a assinatura e valida
 * a validade. A URL do QR é `${origin}/l/${code}`.
 */
export const QR_LOGIN_TTL_SECONDS = 120 * 24 * 60 * 60;
const SIG_LEN = 32;

const toHex = buffer =>
  Array.from(new Uint8Array(buffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');

export const buildQrLoginCode = async ({ id, uuid }, now = Date.now()) => {
  if (!id || !uuid) return null;

  const exp = Math.floor(now / 1000) + QR_LOGIN_TTL_SECONDS;
  const payload = `${id}.${exp}`;
  const encoder = new TextEncoder();
  const key = await crypto.subtle.importKey('raw', encoder.encode(uuid), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
  const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(payload));

  return `${payload}.${toHex(signature).slice(0, SIG_LEN)}`;
};

export const buildQrLoginUrl = async (user, now) => {
  const code = await buildQrLoginCode(user, now);
  return code ? `${window.location.origin}/l/${code}` : null;
};
